import { render, staticRenderFns } from "./ProviderCategoryDiagram.vue?vue&type=template&id=40db261c&scoped=true&"
import script from "./ProviderCategoryDiagram.vue?vue&type=script&lang=ts&"
export * from "./ProviderCategoryDiagram.vue?vue&type=script&lang=ts&"
import style0 from "./ProviderCategoryDiagram.vue?vue&type=style&index=0&id=40db261c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40db261c",
  null
  
)

export default component.exports